<template>
  <!-- Footer -->
  <div class="footer-wrapper">
    <footer class="navbar footer-style">
      <div class="container">
        <ul class="navbar-nav ul-footer">
          <li class="nav-item">
            <span
              >Saiba mais sobre nossa
              <a
                href="#"
                id="privacyFooter"
                class="privacy-style"
                data-toggle="modal"
                data-target="#privacylinkmodal"
                >Politica de privacidade
              </a></span
            >
            <privacy-policy-link></privacy-policy-link>

            <p>
              Sistema Portal de Boletos. @ Copyright Todos os direitos
              reservados. Um produto desenvolvido pela Finnet
            </p>
          </li>
        </ul>
        <a href="#" class="nav-link logo-finnet" id="logoFinnet"
          ><img
            style="width: 80px"
            :src="'static/img/logofnt.png'"
            alt="logofinnet"
        /></a>

        <!-- Right -->
        <div class="icons-footer">
          <a
            class=""
            href="https://www.linkedin.com/company/983678/"
            target="_blank"
            id="linkedinFooter"
          >
            <em
              class="fa fa-linkedin"
              style="color: #312e2e; font-size: 18px"
            ></em>
          </a>
          <a
            class=""
            href="https://www.instagram.com/finnetbrasil/"
            target="_blank"
            id="instagramFooter"
          >
            <em
              class="fa fa-instagram"
              style="color: #312e2e; font-size: 18px"
            ></em>
          </a>
          <a
            class=""
            href="https://www.facebook.com/finnetbrasil/"
            target="_blank"
            id="facebookFooter"
          >
            <em
              class="fa fa-facebook"
              style="color: #312e2e; font-size: 18px"
            ></em>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import PrivacyPolicyLink from "../../common/components/PrivacyPolicyLink";
export default {
  name: "FooterNav",
  components: {
    PrivacyPolicyLink,
  },
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
* {
  padding-bottom: 0;
}

.icons-footer {
  margin-right: 35px;
  padding-top: 10px;
}

.ul-footer {
  margin-left: 40px;
  padding-right: 30px;
  padding-top: 14px;
}

.logo-finnet {
  margin-left: 0px;
  margin-top: -5px;
}

.privacy-style {
  color: #3f3c3c;
}

.footer-style {
  width: 100%;
  /* Height of the footer */
  background-color: rgba(0, 0, 0, 0.2);
  font-size: 11px;
  color: rgb(100, 95, 95);
  padding: 0px 15px 0px 15px;
}

.footer-wrapper {
  width: 100%;
}

@media only screen and (max-width: 960px) {
  .logo-finnet {
    margin-left: -30px;
  }

  .icons-footer {
    margin-right: -10px;
    padding-top: 10px;
  }
  .ul-footer {
    margin-left: -10px;
    padding-right: 30px;
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/FooterNav.vue